import React, { useEffect } from "react";
import "./P_tiempos.css";

import preciosTiemposImg from '../assets/precios_y_tiempos_img_contenido_digital_1.jpeg';
import tiempoEntregaImg from '../assets/precios_y_tiempos_img_contenido_digital_2.jpeg'; // Usa el nombre correcto del archivo




import imgquienes_somosContenidoDigital from '../assets/img1_quienes_somos_contenido_digital.jpg';
import image2 from '../assets/img2_quienes_somos_contenido_digital.jpg';
import image3 from '../assets/img3_quienes_somos_contenido_digital.jpg';
import image4 from '../assets/img4_quienes_somos_contenido_digital.jpg';
import image5 from '../assets/img5_quienes_somos_contenido_digital.jpg';
import image6 from '../assets/img6_quienes_somos_contenido_digital.jpg';
import image7 from '../assets/img7_quienes_somos_contenido_digital.jpg';
import image8 from '../assets/img8_quienes_somos_contenido_digital.jpg';
import image9 from '../assets/img9_quienes_somos_contenido_digital.png';
import imgDerecho from '../assets/img11_quienes_somos_contenido_digital.jpeg';
import imgMarketing from '../assets/img10_quienes_somos_contenido_digital.jpeg';
import image12 from '../assets/img12_quienes_somos_contenido_digital.jpg';
import imgTrigo from '../assets/img_trigo_contenido_digital.jpeg';
import imgBio from '../assets/img_bio_contenido_digital.jpg';



const P_tiempos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <section id="servicios" className="servicios-container">
      <div className="hero_2_1">

        <h2_1> Precios, tiempos y entrega</h2_1>

       
      </div>

      <br />
      <div className="hero_3">
        <p className="intro_1_1">
        💵 Cuanto cuesta digitalizar una asignatura con EduIALogic?
        </p>
        <br />
        <p className="intro_2_2">
        Una asignatura o un curso puede estar compuestos por 1, 2, 3 o más créditos académicos, según lo determine tu institución educativa.

        </p>
        <br />
       
        <p className="intro_2_12">
        💰 Valor por crédito académico: $1.990.000 COP
        </p>
        <br />
        <p className="intro_2_2">
        📦 Cada crédito académico incluye todos los recursos del modelo 🔄 R-Learning 360° (11 pasos):  Un paquete de diseño instruccional robusto y de alta calidad, diseñado con Ingeniería Pedagógica para transformar la experiencia educativa desde el primer clic.  
        </p>
        <br />
        <p className="intro_2_2">
        🎥📄🎧🧠📊💬 — Todo lo que necesitas, en un solo lugar.  
        </p>
        <br />
        <br />
        <p className="intro_1_1">
        ¿Qué recursos incluye una asignatura o un curso según el número de créditos académicos?  
        </p>
        <br />
        
       
       
       
        <div className="tabla-precios-tiempo">
          <table>
            <thead>
              <tr><td></td><td>$1.990.000</td><td>$3.980.000</td><td>$5.970.000</td><td>$7.960.000</td><td>$9.950.000</td></tr>
              <tr>

                <th></th>
                <th>Asignatura o curso de <br />1 crédito académico</th>
                <th>Asignatura o curso de <br />2 créditos académicos</th>
                <th>Asignatura o curso de <br />3 créditos académicos</th>
                <th>Asignatura o curso de <br />4 créditos académicos</th>
                <th>Asignatura o curso de <br />5 créditos académicos</th>
              </tr>
              <tr>

                <th>Sub Temáticas</th>
                <th>5<br />Subtemáticas</th>
                <th>10<br />Subtemáticas</th>
                <th>15<br />Subtemáticas</th>
                <th>20<br />Subtemáticas</th>
                <th>25<br />Subtemáticas</th>
              </tr>
              <tr>

                <th>RECURSOS:</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr><td>📄 Textos disciplinares</td><td>Aprox. 7500 palabras</td><td>Aprox. 15000 palabras</td><td>Aprox. 22500 palabras</td><td>Aprox. 30000 palabras</td><td>Aprox. 37500 palabras</td></tr>
              <tr><td>🎥 Video educativo subtitulado (4-5 min)</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td></tr>
              <tr><td>🧠 Gráficos conceptuales y/o imágenes ilustrativas</td><td>25</td><td>50</td><td>75</td><td>100</td><td>125</td></tr>
              <tr><td>🔗 Diagrama lógico-relacional</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td></tr>
              <tr><td>🎧 Podcast - conversación académica entre presentadores (7-8 minutos)</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td></tr>
              <tr><td>📚 Fuentes científicas curadas. Descargables completos (PDF)</td><td>5</td><td>6</td><td>7</td><td>8</td><td>10</td></tr>
              <tr><td>📘 Glosario técnico. 20 términos, definición y ejemplo de contexto (c/u)</td><td>1 (20)</td><td>2 (40)</td><td>4 (80)</td><td>4 (80)</td><td>5 (100)</td></tr>
              <tr><td>❓ Preguntas analíticas (con respuesta, justificación y ejemplo)</td><td>10</td><td>20</td><td>30</td><td>40</td><td>50</td></tr>
              <tr><td>✅ Preguntas autoevaluativas interactivas con respuesta y justificación</td><td>10</td><td>20</td><td>30</td><td>40</td><td>50</td></tr>
              <tr><td>🧪 Taller de análisis y Fundamentación Teórica con pasos y rúbrica</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td></tr>
              <tr><td>🕵️ Estudio de caso con guía de análisis y rúbrica</td><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td></tr>
              <tr><td>🎮 Historia ramificada (simulación inmersiva)</td><td>1</td><td>1</td><td>2</td><td>3</td><td>4</td></tr>
              
              
              <tr style={{ fontWeight: 'bold' }}>
                <td>💰 Valor de la inversión (COP)</td><td>$1.990.000</td><td>$3.980.000</td><td>$5.970.000</td><td>$7.960.000</td><td>$9.950.000</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <br />

        

        <div className="nota-importante">
          <p>
            💰 <strong>Nota importante:</strong><br /><br />
            Los valores corresponen al estándar de digitalización, con diseño visual, gráficos y navegación idénticos a los que se aprecian en los ejemplos de las asignaturas digitalizadas disponibles en la página web de EduIAlogic. En caso de que la institución educativa requiera personalización del diseño o modificaciones en la navegación, se analizarán los posibles incrementos que dichas adaptaciones pueden generar. 
            <br /><br />

            Los valores presentados incluyen el proceso completo de digitalización de la asignatura, así como el soporte técnico de acompañamiento para resolver posibles incidencias relacionadas con la navegabilidad, la funcionalidad de los enlaces y el acceso a los recursos.
            <br /><br />
            No se contempla en este valor la actualización posterior de los contenidos, la cual se cotiza de manera independiente según el alcance requerido.
            <br /><br />
            Adicionalmente, en caso de que la institución desee contar con una licencia propia de la plataforma para alojar sus contenidos, los costos correspondientes deberán ser asumidos directamente por la institución ante el proveedor de dicha plataforma.
          </p>
        </div>

        <section className="bloque-tiempo-entrega">
          <h2 className="h2_4">⏱️ Tiempo de entrega: Ágil y cumplido</h2>
         
          <div className="tiempo-entrega-contenido">
            <img src={tiempoEntregaImg} alt="Equipo EduIALogic trabajando" />
           
            <div className="texto-tiempo">
              <p>
                En EduIALogic, digitalizamos tu asignatura completa —sea cual sea su tamaño— en tiempo récord.
                <br /><br />
                ¿Tu asignatura tiene 1, 2, 3, 4 o 5 créditos académicos? ¡No importa! <br />
                Cada una se transforma en un contenido digital innovador, listo para implementar, en un plazo ágil y proporcional:
              </p>
            </div>
          </div>

          <div className="tabla-tiempo-entrega">
            <table>
              <thead>
                <tr>
                  <th>Tipo de Asignatura según número de créditos académicos</th>
                  <th>Días Hábiles Estimados</th>
                  <th>Semanas Calendario Aproximadas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Asignatura de 1 crédito académico</td>
                  <td>5 días hábiles</td>
                  <td>1 semana</td>
                </tr>
                <tr>
                  <td>Asignatura de 2 créditos académicos</td>
                  <td>10 días hábiles</td>
                  <td>2 semanas</td>
                </tr>
                <tr>
                  <td>Asignatura de 3 créditos académicos</td>
                  <td>15 días hábiles</td>
                  <td>3 semanas</td>
                </tr>
                <tr>
                  <td>Asignatura de 4 créditos académicos</td>
                  <td>20 días hábiles</td>
                  <td>4 semanas</td>
                </tr>
                <tr>
                  <td>Asignatura de 5 créditos académicos</td>
                  <td>25 días hábiles</td>
                  <td>5 semanas</td>

                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <br />
          <div className="parrafo">
            <p className="intro_2_3">
              Para iniciar, solo necesitamos que se suscriba el contrato y que la institución educativa nos envíe la Guía de Contenidos de la asignatura, utilizando el formato establecido.
            </p>
          </div>
          <br />
          <div className="bloque-descarga-formato">
            <a
              href="https://www.eduialogic.com/GUIA_DE_CONTENIDOS_DE_ASIGNATURA_O_DE_CURSO_DE_EDUCACION_CONTINUA.docx"
              target="_blank"
              rel="noopener noreferrer"
            >
              📥 Puedes descargar el formato aquí
            </a>
          </div>
          <br />

          <div className="bloque-nota-importante">
            <div className="nota-icono-y-texto">
              <span className="icono-info">ℹ️</span>
              <strong>📝 Nota importante:</strong>
            </div>
            <p>

            Los tiempos estimados corresponden a nuestra capacidad operativa estándar bajo el modelo R-Learning 360°. No obstante, participamos activamente como parte del equipo de transformación digital de cada institución, por lo que la planificación del cronograma final se define de manera conjunta, de acuerdo con los requerimientos y prioridades establecidos en el acuerdo comercial.
            <br />
            La digitalización se realiza conforme a nuestro estándar, con diseño visual, elementos gráficos y navegación idénticos a los presentados en los ejemplos de asignaturas digitalizadas disponibles en la página web de EduIAlogic. En caso de que la institución educativa solicite personalización del diseño o modificaciones en la navegación, se evaluarán los posibles incrementos en los tiempos de entrega que dichas adaptaciones puedan implicar..

            </p>
          </div>


        </section>

        <section className="bloque-entrega-asignatura">
          <h2><span role="img" aria-label="box">📦</span> ¿Cómo te entregamos la asignatura estándar?</h2>

          <p>
            En <strong>EduIALogic</strong> diseñamos nuestras entregas pensando en la facilidad de uso, compatibilidad total y
            flexibilidad institucional. Sabemos que cada institución tiene sus propias plataformas y requerimientos técnicos,
            por eso te entregamos la asignatura de manera adaptable para que <strong>tú elijas cómo integrarla</strong>.
          </p>

          <h3><span role="img" aria-label="globe">🌐</span> 1. Entrega vía URL pública o privada</h3>
          <p>
            Te entregamos una <strong>URL única</strong> de la asignatura alojada en nuestra plataforma. Esta puede ser:
          </p>
          <ul>
            <li>Insertada directamente en el LMS de tu institución (Moodle, Canvas, Blackboard, entre otros)</li>
            <li>Compartida por correo, WhatsApp o cualquier canal digital</li>
            <li>Accedida desde intranets, micrositios o redes internas</li>
          </ul>

          <h4>🔹 Ventajas:</h4>
          <ul>
            <li>No requiere integración técnica compleja</li>
            <li>Compatible con cualquier sistema que permita abrir un enlace</li>
            <li>Se visualiza como una experiencia fluida, interactiva y 100 % funcional</li>
            <li>Facilita el acceso multiplataforma (PC, tablet, móvil)</li>
            <li>Posibilidad de actualizaciones inmediatas, sin reinstalación del contenido</li>
          </ul>

          <h3><span role="img" aria-label="iframe">🖥️</span> 2. Entrega vía código IFRAME para embeber directamente</h3>
          <p>
            También entregamos el código HTML de IFRAME, que puedes insertar dentro del LMS institucional o en cualquier
            página web que lo soporte (HTML o editores tipo WordPress, Elementor, Wix, etc.).
          </p>
          <h4>🔹 Ventajas:</h4>
          <ul>
            <li>Permite que el contenido se vea como si fuera nativo del LMS</li>
            <li>No modifica la arquitectura de la plataforma</li>
            <li>Navegación fluida, sin necesidad de abrir ventanas externas</li>
            <li>Mejora la experiencia del usuario al mantenerlo dentro del entorno institucional</li>
            <li>Mantiene actualizaciones automáticas sin tener que volver a integrar</li>
          </ul>

          <h3><span role="img" aria-label="puzzle">🧩</span> 3. Opción de entrega como paquete SCORM (vía Genially)</h3>
          <p>
            Si tu institución requiere el contenido en formato SCORM, lo adaptamos y embebemos en Genially, desde donde
            generamos el paquete compatible con tu LMS. Esto se realiza por solicitud expresa de la institución educativa
            y requiere el <strong>pago de la licencia de Genially</strong>.
          </p>
          <h4>🔹 Ventajas:</h4>
          <ul>
            <li>Compatible con estándares SCORM 1.2 y SCORM 2004</li>
            <li>Permite rastreo desde el LMS: visualizaciones, tiempo de navegación, avance por sección</li>
            <li>Ideal si tu institución necesita generar reportes o registrar actividad del estudiante</li>
            <li>Se integra perfectamente con la mayoría de plataformas educativas</li>
            <li>Entrega del archivo comprimido listo para importar en tu LMS</li>
          </ul>

          <h4><span role="img" aria-label="check">✅</span> Con cualquiera de estas opciones, garantizamos:</h4>
          <ul>
            <li>Interactividad total de los contenidos</li>
            <li>Diseño responsive (adaptado a todos los dispositivos)</li>
            <li>Accesibilidad y compatibilidad con WCAG 2.1 (en evolución)</li>
            <li>Soporte técnico directo de EduIALogic ante cualquier incidencia de visualización o navegación</li>
          </ul>
        </section>


        <div class="nota-importante">
          <strong>🔔 Nota importante:</strong>
          <p>
            Podemos realizar la entrega de la asignatura <strong>fraccionada por créditos académicos</strong>, si así lo requiere la institución educativa. 
            Sin embargo, <strong>este es el único límite posible de fraccionamiento</strong>, ya que <strong>cada crédito académico está diseñada de forma completa e independiente</strong>, 
            siguiendo los <strong>11 pasos del modelo R-Learning 360°</strong>, lo que asegura su 
            <strong> coherencia pedagógica interna, autonomía estructural y alineación didáctica</strong>.
          </p>
          <p>
            Dividir la asignatura más allá del nivel de crédito académico podría afectar la lógica instruccional y la experiencia de aprendizaje diseñada con propósito.
          </p>
        </div>



       
        <p className="intro_2">
           ¿Quieres ver una asignatura digitalizada por nuestro equipo?
          </p>
          <br />
          <p className="intro_3">
           Estos son algunos ejemplos reales de asignaturas transformadas con R-Learning 360°: calidad, estructura y experiencia virtual completa en 11 pasos.
          </p>

          <div className="grid-cursos">
            <div className="curso-card">
              <img src={imgDerecho} alt="Derecho Penal" className="curso-img" />
              <h3>Derecho Penal</h3>
              <p>Asignatura de pregrado</p>
              <a
                href="https://gamma.app/docs/Derecho-Penal-General-l30reok9jr95d33"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>

            <div className="curso-card">
              <img src={imgMarketing} alt="Marketing Digital" className="curso-img" />
              <h3>Fundamentos del Marketing Digital</h3>
              <p>Asignatura de Maestría o de especialización</p>
              <a
                href="https://gamma.app/docs/Fundamentos-del-Marketing-Digital-th1wmg9rybb69a5"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>
            <div className="curso-card">
              <img src={imgTrigo} alt="Trigonometría" className="curso-img_1" />
              <h3>Geometría y Trigonometría</h3>
              <p>Asignatura de grado 11 de Bachillerato</p>
              <a
                href="https://gamma.app/docs/GEOMETRIA-Y-TRIGONOMETRIA-zwd7scg8rs6d77a"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>


            <div className="curso-card">
              <img src={imgBio} alt="Biología" className="curso-img_1" />
              <h3>Biologóa</h3>
              <p>Asignatura de grado quinto de Primaria</p>
              <a
                href="https://gamma.app/docs/BIOLOGIA-rahfqgx8u8tvcw7"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-modern"
              >
                Ver curso
              </a>
            </div>
          </div>


          

          
         

      </div>



    </section>
  );
};

export default P_tiempos;